export default __webpack_public_path__ + "static/media/diploma-bazi.5663fa39.jpeg";